import { render, staticRenderFns } from "./likeDetail.vue?vue&type=template&id=55bde726&scoped=true&"
import script from "./likeDetail.vue?vue&type=script&lang=js&"
export * from "./likeDetail.vue?vue&type=script&lang=js&"
import style0 from "./likeDetail.vue?vue&type=style&index=0&id=55bde726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bde726",
  null
  
)

export default component.exports